import { ListItemIcon, ListItemText, MenuItem, Typography } from '@material-ui/core';
import React from 'react';
import { CalendarDayIcon } from '../../../icons';
import moment from 'moment';

const OverlappingActivity = ({ activity }) => {
    return (
        <MenuItem
            divider
            style={{
                height: 90,
                margin: 0
            }}
            button={false} // TODO: link to booking?
        >
            <ListItemIcon style={{ fontSize: '14px', minWidth: 40 }}>
                <CalendarDayIcon />
            </ListItemIcon>
            <ListItemText
                primary={
                    <>
                        <Typography variant="body1" fontWeight={600}>
                            {activity.booking.activity.name}
                        </Typography>
                        {activity.booking.booking_info.confirmationCode && (
                            <Typography
                                variant="caption"
                                style={{
                                    textTransform: 'uppercase'
                                }}
                                color="textSecondary"
                            >
                                Confirmation code: {activity.booking.booking_info.confirmationCode}
                            </Typography>
                        )}
                    </>
                }
                secondary={
                    <>
                        <Typography variant="caption" color="text.secondary">
                            {moment(activity.booking.activity_start).format('MMMM Do YYYY')}
                            {', '}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                            {moment(activity.booking.activity_start).format('h:mm a')} -{' '}
                            {moment(activity.booking.activity_end).format('h:mm a')}
                        </Typography>
                    </>
                }
            />
        </MenuItem>
    );
};

export default OverlappingActivity;
